import Image, { type ImageProps } from 'next/image'
import Link from 'next/link'
import Text from 'components/text'
import s from './style.module.css'

export interface FeaturedSectionProps {
	eyebrow: string
	heading: string
	image: ImageProps
	link: string
}

export default function FeaturedSection({
	image,
	eyebrow,
	heading,
	link,
}: FeaturedSectionProps) {
	return (
		<div className={s.root}>
			<div className={s.inner}>
				<div className={s.imageContainer}>
					<Image {...image} alt={image.alt} />
				</div>
				<div className={s.content}>
					<div className={s.contentInner}>
						<Text color="neutral-500" variant="body-large" fontWeight="bold">
							{eyebrow}
						</Text>
						<Text color="neutral-900" variant="display-3" as="h2">
							{heading}
						</Text>
					</div>
				</div>
				<Link href={link} className={s.link} aria-label={heading} />
			</div>
		</div>
	)
}
